import React from 'react'

import HorizontalMenuItem, {MenuItemConfig} from "../../../../layout/top/header/h-menu/h-menu-item-2"

type Props = {
    tabs            : MenuItemConfig[]
    currentId       : string

    onSelect        : {(id: any): void}

    // The per-type "+ New X" link, sitting right after the tabs -- optional
    // because not every host offers it (the mention popover picks, it does
    // not create).
    onCreateNew?    : {():void}
    createLabel?    : string
}

// const debug = "EntitySelectorTabs"
const debug = false

// The underlined sub-tabs inside one entity type -- Browse / Recent on the task
// tab, Recent / Upcoming on meetings. A tab that has only one list renders none.
//
// Same `ui5-hmenu menu-underline` the app's own view tabs use, so the selected
// underline and the label weights come from the skin.
//
// The gap is a MARGIN, not padding: `HorizontalMenuItem` marks a counter-less
// item `no-right-padding`, which makes the selected underline `100% + 3px` of
// the item box -- padding would widen the underline along with the gap, where
// margin leaves it hugging the label the way the design has it.
export default function EntitySelectorTabs(props: Props) {
    debug && console.log(debug, 'render', props.currentId)

    // Bottom-aligned, because `menu-underline` hangs the selected item's 3px
    // indicator BELOW the item -- it is meant to land on the row's own border.
    return (
        <div className="entity-selector-tabs flex-row-left-bottom flex-no-shrink">
            <div className="ui5-hmenu menu-underline">
                {_.map(props.tabs, (tab: MenuItemConfig) => {
                    return (
                        <HorizontalMenuItem
                            key         = {tab.id}
                            className   = "m-r-20"
                            data        = {tab}
                            selectedId  = {props.currentId}
                            onClick     = {props.onSelect}
                        />
                    )
                })}

                {/* Inside the same `.ui5-hmenu` as the tabs, not a sibling after it --
                    that's what puts it on their 36px line-height, so the label sits on
                    the same baseline instead of hugging the row's bottom edge. */}
                {props.onCreateNew &&
                    <>
                        <div className="v-separator"/>

                        <div className   = "entity-selector-create-new flex-row-left-center lh-24"
                             onClick     = {props.onCreateNew}
                        >
                            <div className="ui5-ico-12 i5-plus m-r-8"/>
                            <div className="ui5-link-add-item fs-14">{props.createLabel}</div>
                        </div>
                    </>
                }
            </div>
        </div>
    )
}
